import * as React from "react";
import { Checkbox, Dropdown, Input } from "semantic-ui-react";
import { useFormContext, useWatch } from "react-hook-form";
import PlayerCardField from "../Fields/PlayerCardField";
import { PolymorphicPlayerCard } from "../../../../../../services/bedrock";
import { useContext } from "react";
import { PlayerCardSettingsContext } from "../../../../Contexts";

interface CustomTitleFieldProps {
  index: number;
}

const CustomTitleField: React.FC<CustomTitleFieldProps> = ({ index }) => {
  const { control, setValue } = useFormContext<PolymorphicPlayerCard>();
  const { User } = useContext(PlayerCardSettingsContext);

  const title = useWatch({ control, name: `widgets.${index}.owner.title` });
  const useCustomTitle = title !== null && title !== undefined;

  const customTitleCheckbox = (
    <Checkbox
      label="Use custom title"
      checked={useCustomTitle}
      readOnly={!User.hasWritePermission}
      onChange={(_e, data) => {
        setValue(`widgets.${index}.owner.title`, data.checked ? "" : null, { shouldDirty: true });
      }}
    />
  );

  return (
    <div>
      {useCustomTitle ? (
        <PlayerCardField
          index={index}
          fieldName="title"
          fieldLabel={customTitleCheckbox}
          rules={{ required: "This is required." }}
          component={Input}
          placeholder="Title"
        />
      ) : (
        customTitleCheckbox
      )}
    </div>
  );
};
export default CustomTitleField;
